import { createContext } from 'react';
import type { RouteObject } from 'react-router-dom';

export const RouteTableContext = createContext<readonly RouteObject[] | null>(null);
